import darkNewImg from "../../../assets/img/defaultImg/user_dark-230525.png"

export default darkNewImg;